var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunding1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "funding 1",
    clipPath: "url(#clip0_8963_37663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M92.3784 7.74219H89.5709L85.6113 15.6692V33.2088L89.3756 38.2608L92.3782 39.3304C96.4845 35.3223 99.0349 29.7276 99.0349 23.5363C99.0349 17.345 96.4845 11.7502 92.3784 7.74219Z",
    fill: "#FFE02F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M85.7208 23.5354C85.7208 17.3441 88.2713 11.7493 92.3776 7.74127C88.3998 3.85842 82.9618 1.46484 76.9639 1.46484C74.8881 1.46484 72.8793 1.75196 70.9746 2.2879V44.783C72.8793 45.3188 74.8879 45.6061 76.9639 45.6061C82.9618 45.6061 88.3998 43.2125 92.3777 39.3297C88.2713 35.3214 85.7208 29.7266 85.7208 23.5354Z",
    fill: "#FBC700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M98.613 60.6458C96.6986 56.6477 92.2919 58.5375 91.922 58.676L73.9929 63.9802C73.6587 64.079 73.3284 63.8038 73.3733 63.4583C73.5265 62.279 73.4095 60.0149 70.6161 58.9C59.8674 54.6092 58.5855 53.8834 55.8654 53.8402L55.865 53.8398C51.1237 53.8557 48.5715 53.8846 46.4981 54.2418L44.1602 55.3754L42.6465 61.8696L43.1836 67.2408L46.8457 73.1002L50.9563 74.5332C52.7751 74.5352 54.5185 74.8277 56.0763 75.4492L63.0127 78.2184C64.5289 78.7411 68.012 79.5547 71.6265 77.7022C71.6282 77.7014 71.6296 77.7008 71.6296 77.7008C71.9913 77.5409 94.7704 67.4646 95.8454 66.9892C96.5781 66.6134 100.265 64.4015 98.613 60.6458Z",
    fill: "#FFCEBE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M43.6896 62.5102C43.6896 59.3991 44.7376 56.5342 46.4968 54.2441C44.8927 54.5205 43.5749 54.9936 41.7521 55.8094C39.5657 56.7879 37.4893 57.9733 35.544 59.3407C34.536 60.0491 33.4397 60.6188 32.2824 61.0311L31.8867 62.5716L38.1368 76.8295L39.8141 77.4522L44.8402 75.544C46.8751 74.8807 48.9605 74.5328 50.9553 74.535C46.6361 72.2609 43.6896 67.7308 43.6896 62.5102Z",
    fill: "#FFB1A0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.2988 74.1266L37.1621 72.8083V71.6665L31.7967 59.968C31.2311 58.735 29.773 58.1938 28.54 58.7594L21.7008 61.8961L21.0156 63.9741L27.4947 77.8952L36.2988 74.1266Z",
    fill: "#DBEDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M40.8525 79.7129L37.1619 71.666C36.9791 72.4951 36.4264 73.2326 35.5951 73.6137L27.7881 77.1943L26.9727 76.7738L30.8461 85.0961L32.8047 86.1062L39.6439 82.9695C40.877 82.4041 41.418 80.9459 40.8525 79.7129Z",
    fill: "#B5DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.2824 86.1062L13.0402 85.7589L27.9562 78.886L28.645 78.1176L28.5946 76.926L20.4412 59.1489C19.9278 58.0292 18.6035 57.5377 17.4838 58.0512L3.26608 64.5722C2.14634 65.0857 1.65493 66.4099 2.16841 67.5296L10.3699 85.4115L11.2824 86.1062Z",
    fill: "#BF7FE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M34.0639 88.8525L28.5937 76.9258C28.5055 77.7043 28.0261 78.4192 27.2621 78.7695L12.5219 85.5302C11.802 85.8604 11.001 85.7892 10.3691 85.4112L15.7913 97.2332C16.3047 98.3529 17.629 98.8444 18.7487 98.3307L32.9664 91.8097C34.0862 91.2962 34.5776 89.9722 34.0639 88.8525Z",
    fill: "#B166DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M70.174 2.08008H66.6384L57.7206 7.74166L53.5352 14.5558L51.9727 22.466V26.9672L54.7623 35.1615L59.4923 40.9232L65.3966 44.2436L70.1738 44.9914C79.8594 42.6576 87.0562 33.9378 87.0562 23.5358C87.0564 13.1337 79.8596 4.41389 70.174 2.08008Z",
    fill: "#FFE02F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M53.2923 23.5354C53.2923 13.1333 60.489 4.41351 70.1747 2.07969C68.5106 1.67871 66.7737 1.46484 64.9865 1.46484C52.7974 1.46484 42.916 11.3462 42.916 23.5354C42.916 35.7246 52.7974 45.6059 64.9865 45.6059C66.7737 45.6059 68.5106 45.392 70.1747 44.9911C60.489 42.6572 53.2923 33.9374 53.2923 23.5354Z",
    fill: "#FBC700"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M73.2129 64.2123C73.2129 64.2123 72.2731 67.3924 69.0494 66.6027C65.826 65.8131 58.1914 63.9746 58.1914 63.9746",
    stroke: "black",
    strokeWidth: 2.92972,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M73.2129 64.2123C73.2129 64.2123 72.2731 67.3924 69.0494 66.6027C65.826 65.8131 58.1914 63.9746 58.1914 63.9746",
    stroke: "black",
    strokeWidth: 2.92972,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M34.0648 88.8527L20.4412 59.1489C19.9278 58.0292 18.6035 57.5377 17.4838 58.0512L3.26608 64.5722C2.14634 65.0857 1.65493 66.4099 2.16841 67.5296L15.792 97.2334C16.3055 98.3532 17.6297 98.8446 18.7494 98.3311L32.9671 91.8101C34.0869 91.2965 34.5783 89.9724 34.0648 88.8527Z",
    stroke: "black",
    strokeWidth: 2.92972,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M40.8533 79.7135L31.7972 59.968C31.2315 58.735 29.7735 58.1938 28.5405 58.7594L21.7012 61.8962L32.8054 86.107L39.6447 82.9702C40.8777 82.4048 41.4189 80.9468 40.8533 79.7135Z",
    stroke: "black",
    strokeWidth: 2.92972,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M70.4609 16.5811C70.4609 16.5811 68.2594 14.2949 65.2959 14.2949C62.3324 14.2949 60.1732 16.4541 60.1732 18.6768C60.1732 20.8994 62.9674 22.6775 66.5025 23.609C70.0377 24.5404 70.7855 26.368 70.7855 28.3154C70.7855 30.2629 69.0639 32.7748 65.0279 32.7748C60.9918 32.7748 59.1855 29.8395 59.1855 29.8395",
    stroke: "black",
    strokeWidth: 2.92972,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M64.9844 10.8633V13.3469",
    stroke: "black",
    strokeWidth: 2.92972,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M64.9844 33.7188V36.2023",
    stroke: "black",
    strokeWidth: 2.92972,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M64.9846 45.6059C77.1738 45.6059 87.0551 35.7246 87.0551 23.5354C87.0551 11.3462 77.1738 1.46484 64.9846 1.46484C52.7954 1.46484 42.9141 11.3462 42.9141 23.5354C42.9141 35.7246 52.7954 45.6059 64.9846 45.6059Z",
    stroke: "black",
    strokeWidth: 2.92972,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M87.2251 70.8021C91.6625 68.8394 95.4235 67.1757 95.845 66.9894C96.5782 66.6134 100.265 64.4015 98.6129 60.6458C96.6985 56.6477 92.292 58.5375 91.9219 58.676L73.2135 64.2108C73.2135 64.2108 74.4942 60.4481 70.6158 58.9C59.8671 54.6092 58.5852 53.8834 55.8651 53.8402L55.8647 53.8398C47.4554 53.868 45.932 53.9365 41.7528 55.807C39.5665 56.7856 37.4901 57.9709 35.5448 59.3383C34.5367 60.0467 33.4404 60.6165 32.2832 61.0288L39.8147 77.45L44.8407 75.5418C48.731 74.2738 52.8094 74.1455 56.0758 75.449L63.0124 78.2182C64.5286 78.7409 68.0117 79.5545 71.6262 77.702C71.6279 77.7012 71.6293 77.7006 71.6293 77.7006C71.7844 77.6321 76.0569 75.742 80.9735 73.5674",
    stroke: "black",
    strokeWidth: 2.92972,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M90.4916 6.09672C86.755 3.19416 82.0616 1.46484 76.9639 1.46484C74.8881 1.46484 72.8793 1.75196 70.9746 2.2879C80.2534 4.89808 87.0558 13.4222 87.0558 23.5354C87.0558 33.6486 80.2534 42.1727 70.9746 44.7828C72.8793 45.3186 74.8879 45.6059 76.9639 45.6059C89.1531 45.6059 99.0345 35.7246 99.0345 23.5354C99.0345 18.9117 97.6116 14.6206 95.1813 11.0745",
    stroke: "black",
    strokeWidth: 2.92972,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8963_37663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunding1);
export default __webpack_public_path__ + "static/media/funding_1.aa7d9ef8e166cd5cc1438f5023e933da.svg";
export { ForwardRef as ReactComponent };